import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import AboutPreview from './components/AboutPreview';
import ServicesOverview from './components/ServicesOverview';
import ProductsSection from './components/ProductsSection';
import AcademySection from './components/AcademySection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import SEO from '@/components/feature/SEO';

const HomePage = () => {
  return (
    <main>
      <SEO 
        title="Sbdigisolutions | Agencia de Marketing Digital y Automatización" 
        description="Impulsa tu negocio con estrategias de marketing digital, automatización con Inteligencia Artificial, branding y herramientas digitales profesionales." 
      />
      <HeroSection />
      <TrustSection />
      <AboutPreview />
      <ServicesOverview />
      <ProductsSection />
      <AcademySection />
      <TestimonialsSection />
      <CTASection />
    </main>
  );
};

export default HomePage;
